import axios from '../../axios';
import { ADD_VENDOR, UPDATE_VENDOR, DELETE_VENDOR, GET_VENDORS, GET_VENDOR, GET_ONE_VENDORS } from '../types';
import { toast } from 'react-toastify';

export const addVendor = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/account/add', formData);
      if (res.data.code === 1) {
         dispatch({ type: ADD_VENDOR, payload: res.data.data });
         setTimeout(() => {
            toast.success('Vendor added successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const updateVendor = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/account/update', formData);
      if (res.data.code === 1) {
         dispatch({ type: UPDATE_VENDOR, payload: res.data.data });
         setTimeout(() => {
            toast.success('Vendor updated successfully!');
         }, 1000);
      } else {
         toast.error('Failed to update vendor. Please try again.');
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const deleteVendor = (id, companyId) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/account/delete/${id}/${companyId}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_VENDOR, payload: { id } });
         toast.success('Vendor deleted successfully!');
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const updateStatus =
   ({ id, status }) =>
   async (dispatch) => {
      try {
         // const data = {
         //   id,
         //   status: status ? 1 : 0, // Convert boolean to integer (1 for true, 0 for false)
         // };

         const res = await axios.post('/account/update/status', { id, status });

         if (res.data.code === 1) {
            dispatch({ type: UPDATE_VENDOR, payload: res.data.data });
            toast.success('Status updated successfully!');
         } else if (res.data.code === 2) {
            toast.warn(res.data.message);
         } else {
            toast.error('Failed to update status. Please try again.');
         }

         return res.data.code;
      } catch (error) {
         toast.error('An error occurred while updating status.');
         console.error('Error updating status:', error);
         return 0; // Return 0 to indicate failure
      }
   };

export const getVendor = (id) => async (dispatch) => {
   const res = await axios.get(`/account/get/${id}`);
   if (res.data.code === 1) {
      dispatch({ type: GET_VENDOR, payload: res.data.data });
   }
   return res.data.code;
};

export const getVendors = (params) => async (dispatch) => {
   const res = await axios.get('/account/all', { params });
   if (res.data.code === 1) {
      dispatch({ type: GET_VENDORS, payload: res.data.data });
   }
   return res.data.code;
};

export const getSingleVendors = (id) => async (dispatch) => {
   try {
      const res = await axios.get('/account/id', { params: { id: id } });

      if (res.data && res.data.code === 1) {
         dispatch({ type: GET_ONE_VENDORS, payload: res.data.data, single: res.data.data });
      } else {
         console.error('Invalid API response format');
      }
   } catch (error) {
      console.error('Error fetching vendor:', error);
   }
};
